import type { NavigationComponentProps } from '@carvana/merch-tile';
import Link from 'next/link';

type OwnProps = NavigationComponentProps & {
  'data-testid'?: string;
  onAuxClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
};

export default function NavigationLink({
  children,
  'data-adobe-id': dataAdobeId,
  'data-analytics-id': dataAnalyticsId,
  'data-testid': dataTestId,
  href,
  onAuxClick,
  onClick,
  ...props
}: OwnProps) {
  return (
    <Link
      {...props}
      data-adobe-id={dataAdobeId}
      data-analytics-id={dataAnalyticsId}
      data-testid={dataTestId}
      href={href!}
      prefetch={false}
      onAuxClick={onAuxClick}
      onClick={onClick}
    >
      {children}
    </Link>
  );
}
